import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchAudioSchema } from '../../services/AudioSchemaService';
import { AudioSchema, AudioSchemaPatchRequest } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchema, Error, AudioSchemaPatchRequest>;

function usePatchAudioSchema(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchAudioSchema, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchAudioSchema;
